import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 表单定义分页查询
export function listForm(data) {
  return request({ url: serviceName + `/wflow/form/list`, method: 'post', data })
}

// 查询全部表单(供流程绑定下拉)
export function listAllForm() {
  return request({ url: serviceName + `/wflow/form/listAll`, method: 'get' })
}

// 按id查询表单定义
export function getForm(id) {
  return request({ url: serviceName + `/wflow/form/get`, method: 'get', params: { id } })
}

// 新增或修改表单定义
export function saveForm(data) {
  return request({ url: serviceName + `/wflow/form/save`, method: 'post', data })
}

// 删除表单定义
export function deleteForm(id) {
  return request({ url: serviceName + `/wflow/form/delete`, method: 'get', params: { id } })
}

// 自定义SQL数据集查询(级联字段数据源/明细联动填充) data: {sql, params?}
export function queryDataset(data) {
  return request({ url: serviceName + `/wflow/form/dataset`, method: 'post', data })
}

// 自定义SQL取值(首行,支持${key}占位参数) data: {sql, params}
export function querySqlValue(data) {
  return request({ url: serviceName + `/wflow/form/sqlValue`, method: 'post', data })
}
